import { environment } from "./environments/environment";
export const appConfig = environment;
